import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {ChevronLeftIcon} from '@salesforce/retail-react-app/app/components/icons';
import {ensureArray} from '@amblique/king-living/app/utils/utils';
import Link from '@salesforce/retail-react-app/app/components/link';
import {
  Box, Button, Divider, Flex, Text, useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui';
import {ArrowRightIcon} from '@amblique/king-living/app/components/icons';

import {MenuItemContent} from '@amblique/king-living/app/components/mega-menu/shared/menu-item-container';

export const MegaMenuSubcategoryPanel = ({
  category,
  onBackClick,
  transform = 'translateX(100%)',
  zIndex = 3,
  ...props
}) => {
  const styles = useMultiStyleConfig('MegaMenu', {});

  const submenuItems = ensureArray(category?.submenuCollection?.items);

  return (
    <Box
      {...styles.mobilePanel}
      transform={transform}
      zIndex={zIndex}
      {...props}
      sx={{
        willChange: 'transform',
        ...props.sx,
      }}
    >
      <Box {...styles.mobilePanelContent}>
        {onBackClick && (
          <Flex alignItems="center" mb={4}>
            <Button
              leftIcon={<ChevronLeftIcon />}
              variant="ghost"
              onClick={onBackClick}
            >
              <FormattedMessage defaultMessage="Back" id="mega_menu.back_button" />
            </Button>
          </Flex>
        )}
        {category?.link && (
          <Box mb={4}>
            <Link
              target={category.link.openInNewTab ? '_blank' : undefined}
              to={category.link.url || '#'}
            >
              <Text fontSize="sm" fontWeight="semibold">
                <FormattedMessage defaultMessage="Shop All" id="mega_menu.shop_all_button" /> {category.title.toLowerCase()} <ArrowRightIcon ml={2} />
              </Text>
            </Link>
          </Box>
        )}
        {category?.link && <Divider mb={4} />}
        <MenuItemContent
          isMobile={true}
          menuItem={category}
          submenuItems={submenuItems}
        />
      </Box>
    </Box>
  );
};

MegaMenuSubcategoryPanel.displayName = 'MegaMenuSubcategoryPanel';
MegaMenuSubcategoryPanel.propTypes = {
  category: PropTypes.object.isRequired,
  onBackClick: PropTypes.func.isRequired,
  transform: PropTypes.string,
  zIndex: PropTypes.number,
};
